import jump from 'jump.js';

export const scrollTo = (hash, options = {}) => {
  jump(hash, {
    duration: 400,
    ...options
  });
};
